import { Injectable } from '@angular/core';
import {APIBackUrl} from "../../../shared/api-back-url";
import {RequestForm} from "../../../shared/models/request-form";
import { HttpClient } from '@angular/common/http';


@Injectable()
export class RequestListService{

  constructor(
    private http: HttpClient
  ) { }


  listRequestForm(){
    return this.http
      .get( `${APIBackUrl.LIST_REQUEST_FORM}`, {observe: 'response'})
      .map(res => res.body as RequestForm[])
  }
}



// WEBPACK FOOTER //
// /app/src/app/modules/request/request-list/request-list.service.ts